const globalConfigKeys = {
    NOTA_FISCAL_URL_RECEITA_FEDERAL: "notaFiscalUrlReceitaFederal",
    CONSULTA_NOTA_FISCAL_URL: "consultaNotaFiscalUrl",
    DAYS_TO_DEVOLUTION: "daysToDevolution",
    MINUTOS_PEDIDO_ATRASADO: "minutosPedidoAtrasado",
    MINUTOS_INTERVALO_BUSCA_PEDIDO_ATRASADO: "minutosIntervaloBuscaPedidoAtrasado",
    ALERTA_PEDIDO_ATRASADO_HABILITADO: "alertaPedidoAtrasadoHabilitado",
    MENUS_HABILITADOS: "menusHabilitados"
}

const featureKeys = {
    ORDER_DETAILS: {
        NEW_RECEIPT: "newReceipt",
        ALLOW_TAKEOUT_ORDER_WITHOUT_NF: "allowTakeoutOrderWithoutNF"
    }
}


const pageKeys = {
    MODULE_ORDER: {
        DETAILS: {
            NAME: "details",
            FEATURES: {
                ...featureKeys.ORDER_DETAILS
            }
        }
    }
}

const moduleKeys = {
    ORDER: {
        NAME: "order",
        PAGES: {
            ...pageKeys.MODULE_ORDER
        }
    }
}

export const remoteConfigTypes = {
    GLOBAL_CONFIG: { ...globalConfigKeys },
    MODULES: { ...moduleKeys },
    ORDER: { ...moduleKeys.ORDER },
    PAGES: { ...pageKeys }
}